import { instanceEmployee } from "../../../../services/instances";
import type { GetTag, Tag } from "../types/services";

const getTags = async ({ params, alert }: GetTag) => {
  const { showAlert, t } = alert;

  let tags: Tag[] = [];

  await instanceEmployee
    .get("tag", { params: params })
    .then((response) => {
      tags = response.data.data.map((tag: any) => ({
        value: tag?.tag_id.toString() || "",
        label: tag?.tag_name.toString() || "",
        sublabel: "sublabel",
      }));

      localStorage.setItem("all_tags", JSON.stringify(tags));
    })
    .catch(() => {
      showAlert("error", t("alerts.error_get_tags"));
    });

  return { tags };
};

export { getTags };
